const featuredBlog = (() => {
    
    const initBlock = (el) => {
        initTinySlider(el);
    };    
    
    const initTinySlider = (el) => {
        const sliderId = el.dataset.sliderId;
        tns({
            container: `[data-featured-blog-slider="${sliderId}"]`,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            loop: true,
            controls: false,
            autoplayButton: false,
            autoplayTimeout: 5000
        })
    }
    
    return {initBlock};
})();

ControlBinders.register('.featured-blog', el => featuredBlog.initBlock(el));
